import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-finish-mautic',
  templateUrl: './finish-mautic.component.html',
  styleUrls: ['./finish-mautic.component.scss']
})
export class FinishMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) { 

    router.queryParams.subscribe(
      query => {
          // console.log(query);
          this.formData = query;
          setTimeout(() => this.form.nativeElement.submit(), 500);
      }
    )

  }

  ngOnInit() {
    
  }

}
